export default __webpack_public_path__ + "static/media/partner-image2.bf1eb773.jpg";